module.exports = "<div class=\"video-tile box-shadow col\" #videoTile>\n    <h3 class=\"title\">{{ title | translate }}</h3>\n    <img src=\"https://via.placeholder.com/320x220\" alt=\"\" width=\"320\" height=\"220\" #imgThumb>\n    <div>\n      <div [innerHTML]=\"currentText\">{{ description | translate }}</div>\n      <a routerLink=\"/support/videos/{{id}}/video-page\">Read more</a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/video-tile/video-tile.component.html
// module id = ./src/app/shared/components/video-tile/video-tile.component.html
// module chunks = main